import React, { useState, useEffect } from 'react'
import Mapped from './Mapped';
import UnMapped from './UnMapped'
import { getVehicleTypeListById } from '../../CommunityActionCreator';

export default function Main({ communityId }) {
    const [viewScreen, setviewScreen] = useState("Mapped");
    const [filter, setFilter] = useState("")
    const [filterData, setFilterData] = useState([])

    const handlePage = (type) => {
        setviewScreen(type)
        getVehicleTypeListByIdFunction(type)
        setFilter("")
    }

    useEffect(() => {
        getVehicleTypeListByIdFunction(viewScreen)
    }, [])


    const getVehicleTypeListByIdFunction = (screenType) => {
        const type = screenType === "Mapped" ? true : false
        getVehicleTypeListById(communityId, type, (callback) => {
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setFilterData(callback?.data)
            } else {
                setFilterData([])
            }
        })
    }

    return (
        <div className='container-fluid full-height'>
            <div className='row'>
                <ul className='detail-page-hr-sub-tabs' style={{ paddingTop: '10px', margin: '0' }}>
                    <li className={viewScreen === 'Mapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('Mapped')}>Mapped OEM</li>
                    <li className={viewScreen === 'UnMapped' ? 'communication-btn-active communication-btn' : 'communication-btn'} style={{ width: '13%' }} onClick={e => handlePage('UnMapped')}>Unmapped OEM</li>
                </ul>
            </div>

            <div className="FilterFields" style={{ marginTop: '30px' }}>
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Filter</label>
                        <select className='form-control' value={filter} onChange={(e) => setFilter(e.target.value)}>
                            <option value="">Select Vehicle Type</option>
                            {
                                filterData && filterData?.length > 0 ? filterData?.map((value,index)=>{
                                    return(
                                        <option key={index} value={value}>{value}</option>
                                    )
                                })
                            :''}
                        </select>
                    </div>
                    {
                        filter !== "" && filter !== undefined && filter !== null ?
                        <div className="col-sm-4 col-xs-12">
                        <button className="btn btn-primary" style={{marginTop:'22px',padding:'10px 15px'}} onClick={()=>setFilter("")}>Clear Filter</button>
                    </div>
                    :''}
                </div>
            </div>


            {
                viewScreen === "Mapped" ?
                    <Mapped communityId={communityId} filter={filter}/>
                    : ''}
            {
                viewScreen === "UnMapped" ?
                    <UnMapped communityId={communityId} filter={filter}/>
                    : ''}

        </div>
    )
}
